export type TPanels =
  | 'answer'
  | 'ask-question'
  | 'loader'
  | 'questions'
  | 'ai_activation'
  | 'login_required';

export type TOverrideBreakpoints =
  | 'xxs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'xxl'
  | 'tiny'
  | 'mini';

type TViewerQnAPanels = {
  [key: string]: TPanels;
};

export const ViewerQnAPanels: TViewerQnAPanels = {
  ANSWER: 'answer',
  ASK_QUESTION: 'ask-question',
  LOADER: 'loader',
  QUESTIONS: 'questions',
  AI_ACTIVATION: 'ai_activation',
  LOGIN_REQUIRED: 'login_required',
};
